export default __webpack_public_path__ + "static/media/Blackwatch Armguards.e27834be.jpg";